export const HOUR = `${new Date().getHours()} :${new Date().getMinutes()}`;
export const DATE_INVALID = 'Invalid Date';
